import { Controller, useFormContext } from "react-hook-form";
import Select from "../../../UI/Select";

export default function UserMainSpecSelect() {
    const { watch, setValue, control } = useFormContext();
    const specList = watch("specList") || [];
    const mainSpec = watch("main_spec_name");

    return (
        <Controller name='main_spec_name' control={control}
            render={({ field }) => <Select
                options={specList}
                value={field.value}
                isChangeable
                placeholder="Специализация"
                setValue={setValue}
                formName={field.name}
                classes={{
                    select: "universaleditmodal-right-content-select",
                    select_wrapper:
                        "universaleditmodal-right-content-region",
                    select_option:
                        "universaleditmodal-right-content-region-option",
                    select_placeholder:
                        "universaleditmodal-right-content-region-placeholder",
                }}
            />} />
    );
}
